import { render, staticRenderFns } from "./InfosFacture.vue?vue&type=template&id=504c8676&scoped=true"
import script from "./InfosFacture.vue?vue&type=script&lang=js"
export * from "./InfosFacture.vue?vue&type=script&lang=js"
import style0 from "./InfosFacture.vue?vue&type=style&index=0&id=504c8676&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504c8676",
  null
  
)

export default component.exports